/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';

import { SelectedContext } from './AdvancedView';
import { Icon, Hoverable } from '../uiold';
import { themeColors } from '../uiold/Constants';

import { Text as ChakraText } from '../../core-ui';

type Props = {
  isEmpty: boolean;
  singleColumn?: boolean;
  firstSpot?: boolean;
  lastSpot?: boolean;
  lastDate?: boolean;
  onRemove: () => void;
  openWaitlistModal?: () => void;
  openAssignModal?: () => void;
};

type AssignVendorProps = {
  isEmpty: boolean;
  style?: StyleSet;
  singleColumn?: boolean;
  lastSpot?: boolean;
  lastDate?: boolean;
  openModal?: () => void;
};

// type WaitlistProps = {
//   style?: StyleSet,
//   lastSpot?: boolean,
//   lastDate?: boolean,
//   singleColumn?: boolean,
//   openWaitlistModal?: () => void,
// };

type RemoveVendorProps = {
  style?: StyleSet;
  singleColumn?: boolean;
  lastSpot?: boolean;
  lastDate?: boolean;
  onRemove: () => void;
};

function AssignVendor({
  isEmpty,
  singleColumn,
  lastDate,
  openModal,
}: AssignVendorProps) {
  let position: ObjectOf<any> = {};
  if (lastDate && !singleColumn) {
    position.right = 110;
  }

  return (
    <Hoverable
      render={(isHovered, eventHandlers) => (
        <View {...eventHandlers} style={{ margin: 2 }}>
          {isHovered ? (
            <TouchableOpacity
              onPress={openModal}
              style={[
                styles.touchableOpacity,
                {
                  ...position,
                  minWidth: 150,
                  height: 20,
                  backgroundColor: themeColors.blue,
                },
              ]}
            >
              <Icon name="people" size="XS" color="white" />
              <ChakraText color="white" p="1" whiteSpace="nowrap">
                {isEmpty ? t('Assign Vendor') : t('Replace Vendor')}
              </ChakraText>
            </TouchableOpacity>
          ) : (
            <View
              style={[
                styles.circleDiv,
                {
                  backgroundColor: themeColors.blue,
                },
              ]}
            >
              <Icon name="people" size="XS" color="white" />
            </View>
          )}
        </View>
      )}
    />
  );
}

function RemoveVendor({ singleColumn, lastDate, onRemove }: RemoveVendorProps) {
  let position: ObjectOf<any> = {};
  if (lastDate && !singleColumn) {
    position.right = 110;
  }

  return (
    <Hoverable
      render={(isHovered, eventHandlers) => (
        <View {...eventHandlers} style={{ margin: 2 }}>
          {isHovered ? (
            <TouchableOpacity
              onPress={onRemove}
              style={[
                styles.touchableOpacity,
                {
                  ...position,
                  width: 150,
                  height: 20,
                  backgroundColor: '#CE0B24',
                },
              ]}
            >
              <Icon name="remove" size="XS" color="white" />
              <ChakraText color="white" p="1" whiteSpace="nowrap">
                {t('Remove Vendor')}
              </ChakraText>
            </TouchableOpacity>
          ) : (
            <View
              style={[
                styles.circleDiv,
                {
                  backgroundColor: '#CE0B24',
                },
              ]}
            >
              <Icon name="remove" size="XS" color="white" />
            </View>
          )}
        </View>
      )}
    />
  );
}

class Popover extends Component<Props> {
  render() {
    let {
      isEmpty,
      lastDate,
      singleColumn,
      firstSpot,
      lastSpot,
      openAssignModal, // openWaitlistModal,
    } = this.props;
    let top = isEmpty ? -10 : -35;
    let position: ObjectOf<any> = {};
    if (singleColumn) {
      position.left = 6;
      if (firstSpot) {
        top = -10;
      }
    } else if (lastDate) {
      position.right = 30;
    } else {
      position.left = 10;
    }

    return (
      <SelectedContext.Consumer>
        {(context) => (
          <View
            style={{
              ...position,
              top: top,
            }}
          >
            {context && context.selected.size < 1 ? (
              isEmpty ? (
                <React.Fragment>
                  <AssignVendor
                    openModal={openAssignModal}
                    isEmpty={isEmpty}
                    lastDate={lastDate}
                    singleColumn={singleColumn}
                    lastSpot={lastSpot}
                  />
                  {/* <ManageWaitlist
             lastDate={lastDate}
             lastSpot={lastSpot}
             singleColumn={singleColumn}
             openWaitlistModal={openWaitlistModal}
            /> */}
                </React.Fragment>
              ) : (
                this._renderFAB()
              )
            ) : (
              this._renderFAB()
            )}
          </View>
        )}
      </SelectedContext.Consumer>
    );
  }

  // FAB for Floating Action Button
  _renderFAB() {
    let {
      isEmpty,
      singleColumn,
      lastDate,
      lastSpot,
      // openWaitlistModal,
      openAssignModal,
      onRemove,
    } = this.props;
    return (
      <React.Fragment>
        <AssignVendor
          openModal={openAssignModal}
          isEmpty={isEmpty}
          singleColumn={singleColumn}
          lastDate={lastDate}
          lastSpot={lastSpot}
        />
        {/* <ManageWaitlist
         lastDate={lastDate}
         lastSpot={lastSpot}
         openWaitlistModal={openWaitlistModal}
        /> */}
        <RemoveVendor
          singleColumn={singleColumn}
          lastDate={lastDate}
          lastSpot={lastSpot}
          onRemove={onRemove}
        />
      </React.Fragment>
    );
  }
}

let styles = StyleSheet.create({
  touchableOpacity: {
    borderRadius: 10,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  circleDiv: {
    width: 20,
    height: 20,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default Popover;
